// extracted by mini-css-extract-plugin
export var item = "fc-images-module--item--7ccf5";
export var root = "fc-images-module--root--7fd00";
export var small = "fc-images-module--small--b31ba";